import StatusIndicator from './StatusIndicator';
import './status-indicator.scss';

export default StatusIndicator;
